import 'quill/dist/quill.snow.css'

import { colors } from '@mathflat/common/style'
import type { OnboardingPopup } from '@mathflat/domain/Notice'
import { useState } from 'react'
import * as React from 'react'
import SwiperCore from 'swiper'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import _Button from '@/component/atoms/Button/_Button/_Button'
import { _OldButton } from '@/component/atoms/Button/_OldButton'
import { Icon } from '@/component/atoms/Icon'
import modalService from '@/service/modal.service'

import { S } from './index.style'

SwiperCore.use([Navigation, Pagination, Autoplay])

const OnboardingPopupModal = ({ onboardings }: OnboardingPopup) => {
  const [swiper, setSwiper] = useState<SwiperCore | null>(null)
  const [swiperIndex, setSwiperIndex] = useState<number>(0)

  return (
    <S.Modal>
      <S.Left>
        <h4 className="header">이렇게 사용해보세요!</h4>
        <Swiper
          slidesPerView="auto"
          navigation={{
            prevEl: '.swpier-button-prev',
            nextEl: '.swiper-button-next',
          }}
          pagination={onboardings.length > 1}
          allowTouchMove={false}
          autoplay={false}
          resizeObserver={false}
          onAutoplay={(e) => setSwiperIndex(e.activeIndex)}
          onInit={(swiperData) => setSwiper(swiperData)}
        >
          {onboardings.map((onboarding) => {
            return (
              <SwiperSlide key={onboarding.id}>
                <div className="ql-editor">
                  <h3
                    className="swiper-title"
                    dangerouslySetInnerHTML={{ __html: onboarding.title }}
                  />
                  <p
                    className="swiper-content"
                    dangerouslySetInnerHTML={{ __html: onboarding.content }}
                  />
                </div>
              </SwiperSlide>
            )
          })}
          <div className="navigate-wrap">
            <_OldButton
              theme="default"
              width={80}
              className="swpier-button-prev"
              slot="container-start"
              onClick={() => setSwiperIndex(swiper?.activeIndex || 0)}
            >
              <Icon name="navigation_arrow_back" color={colors.gray.$600} />
              &nbsp;이전
            </_OldButton>
            <_Button
              minWidth={80}
              size="m"
              theme="primary"
              className="swiper-button-next"
              slot="container-end"
              onClick={() => setSwiperIndex(swiper?.activeIndex || 0)}
              RightIcon={<Icon name="navigation_arrow_right" />}
            >
              다음&nbsp;
            </_Button>
          </div>
        </Swiper>
      </S.Left>
      <S.Right>
        <video src={onboardings[swiperIndex].imageUrl} muted autoPlay loop />
      </S.Right>
      <S.ButtonWrap>
        <button
          className="close"
          onClick={() => {
            modalService.closeModal()
          }}
        >
          닫기
        </button>
      </S.ButtonWrap>
    </S.Modal>
  )
}

export default OnboardingPopupModal
